var __vue_script__, __vue_template__
require("-!style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6eda5422&file=common_problem.vue&scoped=true!sass!../../../node_modules/vux-loader/src/style-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./common_problem.vue")
__vue_script__ = require("-!babel-loader!../../../node_modules/vux-loader/src/script-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./common_problem.vue")
__vue_template__ = require("-!vue-html-loader!../../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-6eda5422&file=common_problem.vue!../../../node_modules/vux-loader/src/template-loader.js!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./common_problem.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) { (typeof module.exports === "function" ? module.exports.options : module.exports).template = __vue_template__ }



//////////////////
// WEBPACK FOOTER
// ./src/component/static_page/common_problem.vue
// module id = 777
// module chunks = 13